import { CSSObject } from '@emotion/react';
import { HoneycombThemeBase } from '../types';
import { TypographyFamily } from '../types/HoneycombTypography';

export function fontStyles(theme: HoneycombThemeBase) {
    return (family: TypographyFamily): CSSObject => {
        const font = theme.typography.family[family];
        return {
            fontFamily: font.fontFamily,
            fontWeight: font.fontWeight.default,
        };
    };
}
